module.exports = __webpack_public_path__ + "static/media/IGS-navy-upload.cbf356d7.png";